import { Invoices } from "./page/Invoices";
import { InvoiceDetail } from "./invoiceDetail/InvoiceDetail";

const InvoiceRoutes = [
  {
    path: "/invoices",
    element: <Invoices />,
  },
  {
    path: "/invoices/:id",
    element: <InvoiceDetail />,
  },
];

export default InvoiceRoutes;
